const formatPhoneFilter = ( value: string ) => {
    let result = '';
    if (value === null) {
        value = '';
    }

    value = value.trim();
    let prefix = '';
    if ( value.includes('+') ) {
        prefix = value.substring(0, 3) + ' ';
        value = value.substring(3) // Fix duplicated prefix
    }

    const originalPhoneSplitted = value.match(/[0-9]{3}/g);
    if ( originalPhoneSplitted ) {
        result = originalPhoneSplitted.join( ' ' );
    }
    result = prefix + result;
    return result;
};

export default formatPhoneFilter;
